import moment from 'moment'
const Footer = () => {
  const Year = moment().year()
  return (
    <footer className="page-footer px-xl-4 px-sm-2 px-0 py-3">
  <div className="container-fluid d-flex flex-wrap justify-content-between align-items-center text-md-start text-center">
      <p className="col-md-4 mb-0 text-muted">© {Year} Yobas, All Rights Reserved.</p>
  </div>
</footer>
  )
}

export default Footer